import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon(/*#__PURE__*/ _jsx("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.1948 2.2435a1.111 1.111 0 0 1 1.3882 0l7.7778 6.2222c.2635.2109.417.5301.417.8676v9.7778c0 .7563-.2918 1.4876-.8207 2.0316-.53.5451-1.2555.8573-2.0188.8573H5.8395c-.7633 0-1.4889-.3122-2.0188-.8573C3.2917 20.5987 3 19.8674 3 19.1111V9.3333c0-.3375.1534-.6567.417-.8676zm-.417 17.5343H13v-6.6667h-2.2222zm4.4444 0V12c0-.6136-.4974-1.1111-1.1111-1.1111H9.6667c-.6137 0-1.1111.4975-1.1111 1.1111v7.7778h-2.716c-.1536 0-.3073-.0624-.4256-.1841-.1194-.1228-.1918-.2958-.1918-.4826V9.8674L11.889 4.534l6.6667 5.3334v9.2437c0 .1868-.0725.3598-.1918.4826-.1184.1217-.2721.1841-.4255.1841z",
    clipRule: "evenodd"
}), "Home", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
